import React from 'react';
import { User, Calendar, Shield, LogOut, Loader2 } from 'lucide-react';

const ProfileInfoCard = ({ profile, user, formatDate, handleLogout, isLoggingOut }) => {
  return (
    <div className="card">
      <div className="mb-6 flex justify-between items-start">
        <h2 className="text-xl font-semibold">기본 정보</h2>
        <button
          onClick={handleLogout}
          disabled={isLoggingOut}
          className="flex items-center gap-1 px-3 py-2 text-gray-500 hover:text-red-600 hover:bg-red-50 rounded-lg transition-colors"
          title="로그아웃"
        >
          {isLoggingOut ? (
            <>
              <Loader2 className="w-4 h-4 animate-spin" />
              <span className="text-sm">로그아웃 중...</span>
            </>
          ) : (
            <>
              <LogOut className="w-4 h-4" />
              <span className="text-sm">로그아웃</span>
            </>
          )}
        </button>
      </div>

      <div className="space-y-4">
        {/* 프로필 이미지 */}
        <div className="flex items-center gap-4">
          <div>
            {profile?.avatar_url ? (
              <img
                src={profile.avatar_url}
                alt="프로필"
                className="w-20 h-20 rounded-full object-cover"
              />
            ) : (
              <div className="w-20 h-20 bg-gray-100 rounded-full flex-center">
                <User className="w-10 h-10 text-gray-400" />
              </div>
            )}
          </div>
          
          <div>
            <h3 className="text-lg font-medium">{profile?.name || '이름 없음'}</h3>
            <p className="text-sm text-gray-500">{user?.email}</p>
          </div>
        </div>

        {/* 계정 정보 */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 pt-4 border-t">
          <div>
            <p className="text-sm text-gray-500 mb-1">계정 유형</p>
            <div className="flex items-center gap-2">
              <Shield className="w-4 h-4 text-gray-400" />
              <span className="text-sm font-medium">
                {profile?.role === 'admin' ? '관리자' : '일반 사용자'}
              </span>
            </div>
          </div>
          
          <div>
            <p className="text-sm text-gray-500 mb-1">가입일</p>
            <div className="flex items-center gap-2">
              <Calendar className="w-4 h-4 text-gray-400" />
              <span className="text-sm font-medium">
                {formatDate(profile?.created_at || user?.created_at)}
              </span>
            </div>
          </div>
          

        </div>
      </div>
    </div>
  );
};

export default ProfileInfoCard;
